import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssetService } from '../../services/asset-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';

@Component({
  selector: 'asset-dashboard',
  templateUrl: './asset-dashboard.component.html',
  styleUrls: ['./asset-dashboard.component.scss']
})

export class AssetDashboardComponent  extends BaseWidget {
  
  setEntity(data: import("../../../tools/models/baseEntity").BaseEntity) {
  }
  getEntity(): import("../../../tools/models/baseEntity").BaseEntity {
     return null;
  }
  saveRow(): Promise<import("../../../tools/models/baseEntity").BaseEntity> {
    throw new Error("Method not implemented.");
  }

  @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
  ready           : boolean = false;
  openedGeoAreas  : any[] = null;

  geoAreaFilter   : GeoArea ;

  geoArea         : GeoArea ;
  openedGeaoAreas : GeoArea[];

  constructor(
    protected leanUtilsService        : LeanUtilsService,
    protected assetService            : AssetService,
    protected toastr                  : ToastrService,
    protected controlTablesService    : ControlTablesService,
    protected userService             : UserService,
    protected router                  : Router,
    protected location                : Location) {
      super(toastr, leanUtilsService);
  }


//----------------------------------------------------------------------
ngOnInit(){
  super.ngOnInit();
  this.controlTablesService.personGeoAreaGet().then(result => {
    this.geoAreaFilter = result;
  })
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  loadData() {
    this.assetService.getGeoAreaKpis(this.selectedGeoArea.geoAreaCode).then(geoArea => {
      this.geoArea = geoArea;
      this.ready = true;
    })
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
selectedGeoArea : GeoArea = null
selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------
  
selectGeoAreaAndGo(geoArea : GeoArea){ 
  this.selectGeoArea(geoArea);
  this.leanDataForm.hideFilter();
  this.loadData();
}  

//----------------------------------------------------------------------
 returnBack(){
    this.location.back();
  }
//----------------------------------------------------------------------


}
